import React, { useEffect } from 'react';
import { cn } from '../../../../../utils/styles';

interface IInfoHint {
  full?: boolean;
  visible?: boolean;
  handleHint: (payload?: boolean) => void;
}

function InfoHint({ full, visible, handleHint }: IInfoHint) {
  useEffect(() => {
    if (visible === undefined) return;
    setTimeout(() => handleHint(undefined), 2500);
  }, [visible]);

  if (visible === undefined) {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute left-[10px] bottom-[10px] right-[10px] rounded-[5px] h-[130px] flex items-center ' +
          'border-addition1-10 z-10 justify-center text-[12px] capitalize',
        {
          'bg-[#D6E6DF]': visible,
          'bg-[#D6F3FC]': !visible,
          'top-0 bottom-0 h-full left-0 right-0': full,
        },
      )}
    >
      {`Update ${visible ? 'successful' : 'cancelled'}`}
    </div>
  );
}

InfoHint.defaultProps = {
  full: false,
  visible: undefined,
};

export default InfoHint;
